document.addEventListener('DOMContentLoaded', () => {

    function makeformatItemsClickable() {
        document.querySelectorAll('.format_item').forEach(item => {
            item.style.cursor = 'pointer';
            item.addEventListener('click', (e) => {
                if (e.target.closest('label') || e.target.type === 'radio') return;
                const label = item.querySelector('label');
                if (label) label.click();
            });
        });
    }
    setTimeout(() => {
        makeformatItemsClickable();
    }, 150);
/**
 * Tuiles Découverte / Populaire / Meilleur
 * - Affiche le groupe de tuiles correspondant au format sélectionné (sachet/pot)
 * - Calcule les prix : prix variant × quantité × (1 − remise_pourcent/100)
 * - Surbrillance .is-active selon la quantité saisie (1 / 2 / >= 3)
 * - Clic (ou Entrée/Espace) sur une tuile → met à jour l'input quantité
 */
    if (!customElements.get('programme-tiles')) {
        customElements.define(
            'programme-tiles',
            class ProgrammeTiles extends HTMLElement {
                connectedCallback() {
                    this.formId = this.dataset.productFormId;
                    this.formatPosition = parseInt(this.dataset.formatPosition, 10) || 2;
                    this.locale = this.dataset.locale || document.documentElement.lang || 'fr';
                    this.currency = this.dataset.currency || 'EUR';

                    const jsonEl =
                        this.closest('[data-variant-picker]')?.querySelector('#productVariants') ||
                        document.getElementById('productVariants');
                    this.variants = jsonEl ? JSON.parse(jsonEl.textContent) : [];

                    this.qtyInput =
                        document.querySelector(`[name="quantity"][form="${this.formId}"]`) ||
                        document.getElementById(this.formId)?.querySelector('[name="quantity"]') ||
                        document.querySelector('[name="quantity"]');

                    this.tiles = [...this.querySelectorAll('[data-programme-tile]')];

                    this.tiles.forEach((tile) => {
                        tile.addEventListener('click', () => this.setQuantity(tile.dataset.quantity));
                        tile.addEventListener('keydown', (event) => {
                            if (event.key === 'Enter' || event.key === ' ') {
                                event.preventDefault();
                                this.setQuantity(tile.dataset.quantity);
                            }
                        });
                    });

                    if (this.qtyInput) {
                        ['change', 'input'].forEach((evt) =>
                            this.qtyInput.addEventListener(evt, () => this.highlight())
                        );
                    }

                    document.addEventListener('change', (event) => {
                        if (event.target.closest('[data-variant-picker]')) this.refresh();
                    });

                    this.refresh();
                    this.highlight();
                }

                get selectedVariant() {
                    const fields = document.querySelectorAll(
                        `input[type="radio"][form="${this.formId}"]:checked, select[form="${this.formId}"]`
                    );
                    const values = [...fields].map((el) => el.value);
                    return (
                        this.variants.find((v) =>
                            values.every((val) => [v.option1, v.option2, v.option3].includes(val))
                        ) ||
                        this.variants.find((v) => v.available) ||
                        this.variants[0]
                    );
                }

                refresh() {
                    const variant = this.selectedVariant;
                    if (!variant) return;

                    const formatValue = (variant['option' + this.formatPosition] || '')
                        .toLowerCase()
                        .trim();

                    this.querySelectorAll('[data-programme-tiles]').forEach((group) => {
                        group.hidden = group.dataset.format !== formatValue;
                    });

                    // variant.price est en centimes, déjà dans la devise du marché courant
                    // (Shopify résout automatiquement le prix localisé côté Liquid quand
                    // les marchés sont configurés avec conversion/prix locaux)
                    const unitPrice = variant.price;
                    this.tiles.forEach((tile) => {
                        const qty = parseInt(tile.dataset.quantity, 10) || 1;
                        const pct = parseFloat(tile.dataset.discountPct) || 0;
                        const fullPrice = unitPrice * qty;
                        const discounted = Math.round(fullPrice * (1 - pct / 100));
                        const perUnit = discounted / qty;

                        const priceEl = tile.querySelector('[data-tile-price]');
                        const compareEl = tile.querySelector('[data-tile-compare]');
                        const subtitleEl = tile.querySelector('[data-tile-subtitle]');

                        if (priceEl) priceEl.textContent = this.formatMoney(discounted);
                        if (compareEl) {
                            compareEl.hidden = pct <= 0;
                            if (pct > 0) compareEl.textContent = this.formatMoney(fullPrice);
                        }

                        const unitLabel = tile.dataset.unitLabel || '';
                        if (subtitleEl) {
                            subtitleEl.textContent = unitLabel
                                ? `${this.formatMoney(perUnit)}/${unitLabel}`
                                : this.formatMoney(perUnit);
                        }

                        const titre = tile.querySelector('.program-title')?.textContent?.trim() || '';
                        tile.setAttribute(
                            'aria-label',
                            unitLabel ? `${titre} – ${this.formatMoney(perUnit)}/${unitLabel}` : titre
                        );
                    });
                }

                highlight() {
                    const qty = parseInt(this.qtyInput?.value, 10) || 1;
                    this.tiles.forEach((tile) => {
                        const tileQty = parseInt(tile.dataset.quantity, 10);
                        const isActive = tileQty >= 3 ? qty >= 3 : qty === tileQty;
                        tile.classList.toggle('is-active', isActive);
                    });
                }

                setQuantity(qty) {
                    if (!this.qtyInput) return;
                    this.qtyInput.value = qty;
                    this.qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
                    this.highlight();
                }

                formatMoney(cents) {
                    const amount = cents / 100;
                    try {
                        return new Intl.NumberFormat(this.locale, {
                            style: 'currency',
                            currency: this.currency,
                        }).format(amount);
                    } catch (e) {
                        // Devise/locale invalide : repli simple
                        return `${amount.toFixed(2)} ${this.currency}`;
                    }
                }
            }
        );
    }


    // for changing price format in Appstle Subscription at first display and when variant change
    const locale = Shopify.locale;

    function formatPrice(text) {
        // Capture n'importe quel symbole/code devise en préfixe (€, CHF, $...),
        // le montant, et un éventuel suffixe (/item, /unit, etc.)
        return text.replace(/^(\D+)\s*([\d.,]+)\s*(\/\S+)?$/, (match, currency, amount, suffix) => {
            return `${amount} ${currency.trim()}${suffix || ''}`;
        });
    }

    function setAppstlePrices() {
        // Convention "montant puis devise" pour toutes les locales francophones
        // (FR, mais aussi le marché Suisse s'il reste en fr)
        if (locale && locale.startsWith('fr')) {
            document.querySelectorAll('.appstle_subscription_amount, .appstle_subscription_compare_amount, .appstle_one_time_unit_price, .appstle_selling_plan_unit_price')
            .forEach((el) => {
                const original = el.textContent.trim();
                const formatted = formatPrice(original);
                if (original !== formatted) {
                    el.textContent = formatted;
                }
            });
        }
    }

    const observer = new MutationObserver((mutations) => {
        let shouldUpdate = false;

        for (const m of mutations) {
            // Cas 1: new nodes added (initial)
            if (m.type === 'childList') {
                const relevant = [...m.addedNodes].some(node =>
                    node.nodeType === 1 && (
                        node.classList?.contains('appstle_subscription_amount') ||
                        node.classList?.contains('appstle_subscription_compare_amount') ||
                        node.classList?.contains('appstle_one_time_unit_price') ||
                        node.classList?.contains('appstle_selling_plan_unit_price') ||
                        node.querySelector?.('.appstle_subscription_amount')
                    )
                );
                if (relevant) { shouldUpdate = true; break; }
            }

            // Cas 2: updated text directly (variant changed)
            if (m.type === 'characterData') {
                const parent = m.target.parentElement;
                if (
                    parent?.classList.contains('appstle_subscription_amount') ||
                    parent?.classList.contains('appstle_subscription_compare_amount') ||
                    parent?.classList.contains('appstle_one_time_unit_price') ||
                    parent?.classList.contains('appstle_selling_plan_unit_price')
                ) {
                    shouldUpdate = true; break;
                }
            }

            // Cas 3: subtree updated by a know element
            if (m.type === 'childList' && m.target) {
                if (
                    m.target.classList?.contains('appstle_subscription_amount') ||
                    m.target.classList?.contains('appstle_subscription_compare_amount') ||
                    m.target.classList?.contains('appstle_one_time_unit_price') ||
                    m.target.classList?.contains('appstle_selling_plan_unit_price')
                    
                ) {
                    shouldUpdate = true; break;
                }
            }
        }

        if (shouldUpdate) {
            setAppstlePrices();
        }
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true,
        characterData: true,
        characterDataOldValue: true
    });

    
    setTimeout(setAppstlePrices, 500);

});